var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.5C12.8978 1.5 13.2794 1.65804 13.5607 1.93934C13.842 2.22064 14 2.60218 14 3V21C14 21.3978 13.842 21.7794 13.5607 22.0607C13.2794 22.342 12.8978 22.5 12.5 22.5H3.5C3.10218 22.5 2.72064 22.342 2.43934 22.0607C2.15804 21.7794 2 21.3978 2 21V3C2 2.60218 2.15804 2.22064 2.43934 1.93934C2.72064 1.65804 3.10218 1.5 3.5 1.5H12.5ZM3.5 0C2.70435 0 1.94129 0.316071 1.37868 0.87868C0.81607 1.44129 0.5 2.20435 0.5 3V21C0.5 21.7956 0.81607 22.5587 1.37868 23.1213C1.94129 23.6839 2.70435 24 3.5 24H12.5C13.2956 24 14.0587 23.6839 14.6213 23.1213C15.1839 22.5587 15.5 21.7956 15.5 21V3C15.5 2.20435 15.1839 1.44129 14.6213 0.87868C14.0587 0.316071 13.2956 0 12.5 0L3.5 0Z",
    fill: "#25BCBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 21C8.39782 21 8.77936 20.842 9.06066 20.5607C9.34196 20.2794 9.5 19.8978 9.5 19.5C9.5 19.1022 9.34196 18.7206 9.06066 18.4393C8.77936 18.158 8.39782 18 8 18C7.60218 18 7.22064 18.158 6.93934 18.4393C6.65804 18.7206 6.5 19.1022 6.5 19.5C6.5 19.8978 6.65804 20.2794 6.93934 20.5607C7.22064 20.842 7.60218 21 8 21Z",
    fill: "#25BCBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone2);
export default __webpack_public_path__ + "static/media/Phone2.90c5186c92d3627658a12a6f0c2f99dc.svg";
export { ForwardRef as ReactComponent };